<template>
  <Content @back="$router.push('/home')">
    <template v-slot:nav_left>领队管理</template>
    <template v-slot:nav_right>
      <div
        class="yioks_btn"
        @click="
          addLeader = true;
          isEdit = false;
          leaderInfo = {};
        "
      >
        <!-- <v-icon name="plus" scale="1"  style="margin-right: .1rem"></v-icon> -->
        添加领队
      </div>
      <div class="yioks_btn" @click="batchAdd = true">批量导入领队</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select
            v-model="selectVal.organUuid"
            class="yioks_select"
            @change="changeSelectOrg"
          >
            <option v-if="selectOrganList.length > 1" value="">
              全部区体育行政部门
            </option>
            <option
              v-for="item in selectOrganList"
              :key="item.organUuid"
              :value="item.organUuid"
            >
              {{ item.organShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.youthUuid"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option v-if="selectCenterList.length !== 1" value="">
              全部培训机构
            </option>
            <option
              v-for="item in selectCenterList"
              :key="item.uuid"
              :value="item.uuid"
            >
              {{ item.youthShortName }}
            </option>
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          />
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th name"><strong>领队姓名</strong></div>
              <div class="th idNumber"><strong>领队身份证号</strong></div>
              <div class="th phone"><strong>领队手机号</strong></div>
              <div class="th bindTeam"><strong>绑定球队</strong></div>
              <div class="th status"><strong>领队状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in leaderList"
                    :key="index"
                    class="tr"
                  >
                    <div class="td name">
                      <p>{{ item.idName || "--" }}</p>
                    </div>
                    <div class="td idNumber">
                      <p>{{ item.idNumber | filterIdNumberPrivacy}}</p>
                    </div>
                    <div class="td phone">
                      <p>{{ item.phone | filterPhone }}</p>
                    </div>
                    <div class="td bindTeam">
                      <p>{{ item.shortName || "--" }}</p>
                    </div>
                    <div class="td status">
                      <p>{{ item.userStatus | centerStatus }}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)"
                          >查看</span
                        >
                        <span class="split">/</span>
                        <span class="item" @click="editLeader(index)"
                          >编辑</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :page.sync="page" />
      <template v-if="batchAdd">
        <el-dialog
          :visible.sync="batchAdd"
          width="500px"
          title="批量导入领队"
          :close-on-click-modal="false"
          custom-class="yioks_alert2"
        >
          <el-form
            ref="batchInfo"
            :model="batchInfo"
            :rules="formRules"
            label-width="80px"
          >
            <el-form-item label="区体育行政部门" prop="organUuid">
              <el-select
                v-model.trim="batchInfo.organUuid"
                style="width: 100%"
                placeholder="请选择区体育行政部门"
              >
                <el-option
                  v-for="item in batchOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="青训中心" prop="youthUuid">
              <el-select
                v-model.trim="batchInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择区体育行政部门后再选择会员青训中心"
                @change="changeBathCenter"
              >
                <el-option
                  v-for="item in batchCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <UploadFile
            v-if="batchAdd"
            request="/api/zuxie/guozi/leader/upload/excel"
            :templateFile="tempUrl"
            @callBack="batchAddLeader"
          />
        </el-dialog>
      </template>
      <template v-if="addLeader">
        <AddLeaderDialog
          :addLeader.sync="addLeader"
          :isEdit="isEdit"
          :leader="leaderInfo"
          @hideLeaderDialog="hideLeaderDialog"
        ></AddLeaderDialog>
      </template>
    </template>
  </Content>
</template>

<script>
import "vue-awesome/icons/regular/edit";
import leader from "@/api/leader";
// import coach from '@/api/coach'
import squad from "@/api/squad";

import person from "@/assets/images/common/person.jpg";
// import formRules from '@/utils/formRules'
import rulesMixin from "@/utils/formRules/leader";
import { userStatus } from "@/utils/yioks_data";
import { centerStatus } from "@/utils/yioks_filter";
import storage from "@/utils/storage";
import { ops } from "@/utils/scrollIndialog";

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    UploadFile: () => import("@/components/UploadFile"),
    AddLeaderDialog: () => import("@/components/leader"),
  },
  filters: {
    centerStatus,
  },
  mixins: [rulesMixin],
  data() {
    return {
      ops,
      leaderList: [],
      total: 0,
      page: 0,
      pageSize: 20,
      uuid: storage.get("userInfo").uuid,
      userRole: storage.get("userInfo").userRole,
      empty: false,
      showList: false,
      selectVal: {
        keyWord: "",
        youthUuid: "",
        organUuid: "",
      },
      person,
      addLeader: false,
      leaderInfo: {
        phone: "",
        idName: "",
        idNumber: "",
        organUuid: "",
        youthUuid: "",
        headImgUrl: "",
        password: "",
        confirmPassword: "",
        userStatus: "EFFECTIVE",
      },
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
      },
      loading: true,
      keywords: "",
      addbtnLoading: false,
      batchAdd: false,
      isEdit: false,
      batchCenterList: [],
      batchOrganList: [],
      batchSquadList: [],
      selectCenterList: [],
      selectOrganList: [],
      selectSquadList: [],
      userStatus,
    };
  },
  watch: {
    page() {
      this.changeQuery();
    },
    "batchInfo.organUuid": {
      handler(val) {
        this.$set(this.batchInfo, "youthUuid", "");
        this.$set(this.batchInfo, "youthShortName", "");
        if (val) {
          this.batchCenterList =
            this.batchOrganList.find((item) => {
              return item.organUuid === this.batchInfo.organUuid;
            }).youthList || [];
          this.batchInfo.organShortName = this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).organShortName;
          if (this.batchCenterList.length === 1) {
            this.$set(
              this.batchInfo,
              "youthUuid",
              this.batchCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthShortName",
              this.batchCenterList[0].youthShortName
            );
          }
        } else {
          this.batchCenterList = [];
        }
      },
    },
    batchAdd(val) {
      if (!val) {
        this.batchInfo = {
          organUuid: "",
          organShortName: "",
          youthShortName: "",
          youthUuid: "",
        };
        this.batchCenterList = [];
        this.$refs["batchInfo"].resetFields();
      }
    },
  },
  computed: {
    tempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/leaderClub.xlsx";
      } else {
        return "/uploads/templateFile/leader.xlsx";
      }
    }
  },
  created() {
    const { page, keyWord, organUuid, youthUuid } = this.$route.query;
    page && (this.page = Number(page));
    keyWord && this.$set(this.selectVal, "keyWord", keyWord);
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    this.getOrganListAndCenterList(this.getLeaderAccount);
  },
  methods: {
    getLeaderAccount() {
      this.loading = true;
      this.empty = false;
      this.showList = false;
      // const userRole = storage.get('userInfo').userRole
      let request = leader.getLeaderAccountByYouth;
      if (this.userRole === "organ") {
        request = leader.getLeaderAccountByOrg;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = leader.getLeaderAccountBySystem;
      }
      request({
        page: this.page,
        size: this.pageSize,
        key: this.selectVal.keyWord,
        organUuid: this.selectVal.organUuid,
        youthUuid: this.selectVal.youthUuid,
      })
        .then((res) => {
          this.loading = false;
          let data = res.content;
          this.total = res.totalElements;
          if (data.length) {
            this.leaderList = data;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    hideLeaderDialog(val) {
      this.addLeader = val;
      this.getLeaderAccount();
    },
    editLeader(index) {
      this.leaderInfo = { ...this.leaderList[index] };
      if (!this.leaderInfo.headImgUrl) this.leaderInfo.headImgUrl = "";
      this.isEdit = true;
      this.addLeader = true;
    },
    goInfo(uuid) {
      this.$router.push({
        path: "info",
        query: {
          uuid,
        },
      });
    },
    batchAddLeader(url) {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          let data = {
            ...this.batchInfo,
            path: url,
          };
          leader.batchAddLeader(data).then((res) => {
            this.$message.success("导入成功");
            this.batchAdd = false;
            this.getLeaderAccount();
          });
        }
      });
    },
    changeSelectOrg() {
      this.$set(this.selectVal, "youthUuid", "");
      if (this.selectVal.organUuid) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.selectVal.organUuid;
          }).youthList || [];
        if (this.selectCenterList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.selectCenterList[0].uuid);
        }
      } else {
        this.selectCenterList = [];
        this.$set(this.selectVal, "youthUuid", "");
      }
      this.changeQuery(true);
    },
    changeBathCenter() {
      this.batchInfo.youthShortName = this.batchCenterList.find((item) => {
        return item.uuid === this.batchInfo.youthUuid;
      }).youthShortName;
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          keyWord: this.selectVal.keyWord,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
        },
      });
      this.getLeaderAccount();
    },
    getOrganListAndCenterList(geList) {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.selectOrganList = res;
        this.batchOrganList = res;
        if (res.length === 1) {
          this.$set(
            this.selectVal,
            "organUuid",
            this.selectOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organUuid",
            this.batchOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organShortName",
            this.batchOrganList[0].organShortName
          );
          this.batchCenterList =
            this.batchOrganList.find((item) => {
              return item.organUuid === this.selectVal.organUuid;
            }).youthList || [];
          this.selectCenterList = this.batchCenterList;
          if (this.batchCenterList.length === 1) {
            this.$set(
              this.selectVal,
              "youthUuid",
              this.selectCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthUuid",
              this.batchCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthShortName",
              this.batchCenterList[0].youthShortName
            );
          }
        }
        this.selectVal.organUuid && this.setCenterList();
        geList();
      });
    },
    setCenterList() {
      if (this.selectCenterList.length === 0) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.selectVal.organUuid;
          }).youthList || [];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .name
      width 18%
    .idNumber
      width 23%
    .phone
      width 20%
    .bindTeam
      width 15%
    .status
      width 12%
    .opt
      width 12%
      p
        width 100%
        text-align center
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
.demo-ruleForm
  height 500px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
</style>
